module.exports = __webpack_public_path__ + "static/ideanest-web-27a567814d8e64bb58bba779b37cf820.jpg";